import { createFileRoute } from "@tanstack/react-router";
import ArticleListing from "@/pages/ArticleListing";
import { SITE_ORIGIN } from "@/lib/routeSeo";

const title = "Kreditkarten-Ratgeber: Tipps, Vergleiche & Wissen";
const description =
  "Ratgeber rund um Kreditkarten: Kartentypen, Gebühren im Ausland, Versicherungen, Schufa und wie Sie die passende Karte finden.";
const url = `${SITE_ORIGIN}/ratgeber`;

export const Route = createFileRoute("/ratgeber/")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: url },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
    ],
    links: [{ rel: "canonical", href: url }],
  }),
  component: ArticleListing,
});
